import React from 'react';
import css from './AdminPageClubsOffers.css';
import Panel from './Panel';
import AdminPageHolder from '../AdminPanelsPage/AdminPageHolder';

const api = '/api/clubs-offers';

export default () => (
    <AdminPageHolder
        title="AdminPageClubsOffers"
        schema={{
            '@context': 'http://schema.org',
            '@type': 'AdminPageClubsOffers',
            description: 'Admin panel',
            name: 'Admin panel',
        }}
    >
        <h1 className={css.pageTitle}>Clubs Offers</h1>
        <Panel api={api} />
    </AdminPageHolder>
);
